import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Paper,
  alpha,
  useTheme
} from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../core/hooks/useStore";
import { RootState } from "../../core/store/store";
import projectsSlice from "./projects.slice";

const SearchProjects = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const nameFilter = useSelector(
    (state: RootState) => state.projects.filter?.nameFilter
  );
  const [searchValue, setSearchValue] = useState(nameFilter || "");

  const handleSearch = () => {
    dispatch(projectsSlice.actions.setNameFilter(searchValue));
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
    // Auto-search on clear
    if (event.target.value === "") {
      dispatch(projectsSlice.actions.setNameFilter(""));
    }
  };
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, maxWidth: '600px' }}>
      <TextField
        placeholder="Search projects..."
        value={searchValue}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        size="small"
        fullWidth
        aria-label="Search projects by name"
        sx={{ flex: 1 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
      <IconButton
        onClick={handleSearch}
        size="small"
        aria-label="Search projects"
        sx={{
          bgcolor: theme.palette.primary.main,
          color: 'white',
          '&:hover': {
            bgcolor: theme.palette.primary.dark,
          },
          padding: '7px',
        }}
      >
        <SearchIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default SearchProjects;